import { render, staticRenderFns } from "./AnalysisDetailPage.vue?vue&type=template&id=65a3e993&scoped=true"
import script from "./AnalysisDetailPage.vue?vue&type=script&lang=js"
export * from "./AnalysisDetailPage.vue?vue&type=script&lang=js"
import style0 from "./AnalysisDetailPage.vue?vue&type=style&index=0&id=65a3e993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3e993",
  null
  
)

export default component.exports